import * as Api from '@ViewModels';
import { useContactUpdateMutation } from '../../../../../queries';

interface UpdateContactRequest {
	contactId: string;
	contactData: Partial<Api.IContact>;
}

type Props = {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
};

export const useUpdateContactHelper = ({ onSuccess, onError }: Props) => {
	const { mutate: updateContact, isPending } = useContactUpdateMutation({
		onSuccess: () => {
			if (onSuccess) {
				onSuccess();
			}
		},
		onError: error => {
			if (onError) {
				onError(error);
			}
		},
	});

	const updateContactHelper = ({ contactId, contactData }: UpdateContactRequest) => {
		if (!contactData) {
			throw new Error('Contact data not found. Please refresh and try again.');
		}

		const entityToSave = Api.excludeKeysOf({ ...contactData }, ['keyFacts']) as Api.IContact;

		updateContact({
			contactId,
			contactData: entityToSave,
		});
	};

	return { updateContactHelper, isLoading: isPending };
};
